import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiUsers, FiCpu, FiMessageCircle, FiArrowRight } from 'react-icons/fi';

const Services = () => {
  const services = [
    {
      title: "1-on-1 Coaching",
      icon: FiCpu,
      desc: "A confidential thinking partnership to find your voice, navigate conflict, and lead with clarity in high-pressure environments."
    },
    {
      title: "Team Workshops",
      icon: FiUsers,
      desc: "Interactive sessions to build trust, shared language, and alignment using the 5 Voices™ and healthy conflict frameworks."
    },
    {
      title: "GiANT 5 Voices™",
      icon: FiMessageCircle,
      desc: "Discover your leadership voice and learn to communicate effectively with people who are wired differently than you."
    }
  ];

  return (
    <section id="services" className="py-32 bg-brand-gray relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-24 max-w-3xl mx-auto">
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-brand-purple font-bold tracking-[0.3em] uppercase text-xs mb-4 block"
          >
            Our Approach
          </motion.span>
          <h2 className="text-5xl lg:text-6xl font-black text-brand-black tracking-tight mb-6">
            The Science of <span className="text-brand-purple">Impact.</span>
          </h2>
          <p className="text-xl text-gray-500 font-medium">
            We don't do fluff. We provide practical tools and frameworks that create sustainable behavior change for you and your organization.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ y: -5 }}
              className="group p-12 rounded-3xl bg-white border border-gray-100 hover:border-brand-purple/20 shadow-sm hover:shadow-premium transition-all duration-300 flex flex-col items-start"
            >
              <div className="w-16 h-16 bg-brand-gray rounded-2xl flex items-center justify-center mb-8 group-hover:bg-brand-purple group-hover:text-white transition-all duration-300">
                <SafeIcon icon={service.icon} className="text-brand-black group-hover:text-white w-7 h-7 transition-colors duration-300" />
              </div>
              
              <h3 className="text-3xl font-bold text-brand-black mb-4 group-hover:text-brand-purple transition-colors">{service.title}</h3>
              
              <p className="text-gray-500 font-medium leading-relaxed mb-8 text-lg">{service.desc}</p>
              
              <Link to="/contact" className="mt-auto flex items-center text-brand-black font-bold text-sm tracking-wide group-hover:translate-x-2 transition-transform cursor-pointer uppercase">
                <span>Learn More</span>
                <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 text-brand-purple" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;